import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { OpenPositionsSection } from './components/OpenPositionsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { CultureSection } from './components/CultureSection';
import { ApplicationSection } from './components/ApplicationSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://businessdevelopmentauthority.net';

const CareersPage: React.FC = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/careers`,
        'url': `${SITE_URL}/careers`,
        'name': 'Careers at Business Development Authority - Join Our AI Team',
        'description': 'Join Business Development Authority and help shape the future of AI consulting, process automation, and digital transformation. View open positions and apply today.',
        'isPartOf': { '@id': SITE_URL },
      },
      {
        '@type': 'Organization',
        'name': 'Business Development Authority',
        'url': SITE_URL,
        'description': 'AI strategy consulting, process automation, machine learning, and digital transformation services.',
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': '725 E Road 2 N Unit 1494',
          'addressLocality': 'Chino Valley',
          'addressRegion': 'AZ',
          'postalCode': '86323',
          'addressCountry': 'US',
        },
        'hiringOrganization': {
          '@type': 'Organization',
          'name': 'Business Development Authority',
          'sameAs': SITE_URL,
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <OpenPositionsSection />
          <BenefitsSection />
          <CultureSection />
          <ApplicationSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default CareersPage;
